<template>
  <div class="page_admin_dashboard">
  </div>
</template>

<script>
export default {
  name: "admin_dashboard"
}
</script>